import {
  BasePagination,
  CommonPageResponse,
  CommonResponse,
  HTTP_RESULT,
  LEVEL_TYPE,
  SORT_DIRECTION,
  SORT_TYPE,
} from "api/interfaces/commonInterface.interface";
import { ProfileAccountInfoFromServer } from "api/interfaces/accountInterface.interface";
import { VERIFY_TYPE } from "pages/auth/verify2fa/resendCode/resendCode";
import {
  NVRRoleLevel,
  SpectrumRoleLevel,
} from "pages/users/userGroup/add/PermissionPolicy";
import { RestrictedRecorder } from "./recorderInterface.interface";

export enum START_PAGE {
  MAP_VIEW = "MapView",
  CHART_VIEW = "ChartView",
  ADMIN_VIEW = "MapView",
  ACCOUNT_VIEW = "AccountList",
  RECORDER_VIEW = "RecorderList",
}

export interface resetInfo {
  email: string;
}

export interface GetTokenResponse {
  error: number;
  result: {
    password: string;
    email: string;
    token: string;
    tokenExpire: number;
    accountId: string;
    isActive: boolean;
    dwAccountActive: boolean;
    passwordResetId: string;
    isTrial: boolean;
    firstName: string;
    lastName: string;
    phone: string;
  };
}
export interface UserInfo {
  userId: string;
  email: string;
  phone?: string;
  name: string;
  profileImg: string;
  isAccount: number;
  startPage: number;
  totalAccount: number;
  theme: "light" | "dark";
  verify2fa: boolean;
  use2faCode: VERIFY_TYPE;
  userLevel: LEVEL_TYPE;
  accounts: ProfileAccountInfoFromServer;
  userKey: string;
  isSuspended?: number;
  botInfo: string;
  level: LEVEL_TYPE[];
}

export interface ResponseUserInfo {
  error: number;
  errorString: string;
  result: UserInfo;
}

export interface GetUserResponse {
  userId: number;
  accountId: number;
  userGroupId: number;
  name: string;
  email: string;
  phone: string;
  address: string;
  photo: string;
  startPage: START_PAGE;
  newsLetter: boolean;
  companyName: string;
  companyAddress: string;
  companyPhoneNumber: string;
  department: string;
  description: string;
  notifyAlertMail: string;
  notifyReportMail: string;
  notifySms: string;
  createAt: string;
  lastLoggedOn: string;
  uerRole: {
    id: number;
    viewCameraFootage: boolean;
    viewRecordedFootage: boolean;
    viewReport: boolean;
    viewAlert: boolean;
    ptzControl: boolean;
    accountManagement: boolean;
    addEditReport: boolean;
    addEditAlert: boolean;
    userManagement: boolean;
  };
  accountDto: {
    accountId: number;
    parentId: number;
    name: string;
    level: string;
    accountNumber: string;
    timezone: string;
    dateFormat: string;
    timeFormat: string;
  };
}

export interface UserDetail {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  photo: string;
  startPage: START_PAGE;
  newsLetter: boolean;
  companyName: string;
  companyAddress: string;
  companyPhoneNumber: string;
  department: string;
  jobTitle: string;
  notifyAlertMail: boolean;
  notifyReportMail: boolean;
  notifySms: boolean;
  notifyPush: boolean;
  use2faCode: string;
  createAt?: string;
  lastLoggedOn?: string;
  provider: string;
  level?: string[];
  verifyPhone: boolean | null;
  passkeyList: Passkey[];
}

export interface Passkey {
  keyName: string;
  passkeyId: string;
  createAt: string;
}

export interface UserDetailOld {
  userId: string;
  firstName: string;
  lastName: string;
  // name: string;
  email: string;
  phone: string;
  address: string;
  photo: string;
  startPage: START_PAGE;
  newsLetter: boolean;
  companyName: string;
  companyAddress: string;
  companyPhoneNumber: string;
  createAt?: string;
  lastLoggedOn?: string;
  provider: string;
  level?: string[];
}

export interface GetUserDetailResponse {
  error: number;
  errorString: string;
  result: UserDetail;
}

export interface GetUserProfileResponse {
  error: number;
  errorString: string;
  result: any;
}

export interface UserList {
  userId: string;
  accountId: string;
  userGroupId: number;
  name: string;
  email: string;
  phone: string;
  address: string;
  photo: string;
  startPage: START_PAGE;
  newsLetter: string;
  companyName: string;
  companyAddress: string;
  companyPhoneNumber: string;
  department: string;
  description: string;
  notifyAlertMail: string;
  notifyReportMail: string;
  notifySms: string;
  createAt: string;
  lastLoggedOn: string;
  restrictList: RestrictedRecorder[];
  groupName: string;
  roleName: string;
}

export interface UserListResponse {
  result: HTTP_RESULT;
  error_code: string;
  count: number;
  pageNum: number;
  pageLimit: number;
  keyword: string;
  sortType: string;
  sortDirection: SORT_TYPE;
  data: UserList[];
}

export type GetUserRequest = BasePagination;

export interface User {
  userId: string;
  userName: string;
  roleId: string;
  roleName: string;
  groupId: string;
  groupName: string;
  description: string;
}

export interface UserListByAccountId {
  userId: string;
  email: string;
  name: string;
  roleId: string;
  roleName: string;
  groupId: string;
  groupName: string;
  description: string;
}

export interface GetUserListResposne extends CommonPageResponse {
  result: UserDto[];
}
export interface AddUserDto {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  description: string;
  userGroups: UserGroupInfo[];
}

export interface EditUserDto extends AddUserDto {
  name: string;

  parentAccount: string;
  companyName: string;
  companyPhoneNumber: string;
  department: string;
  jobTitle: string;
  notifyAlertMail: boolean;
  notifyReportMail: boolean;
  notifySms: boolean;
}
export interface UserDto {
  userId: string;
  name: string;
  firstName: string;
  lastName: string;
  profileImg: string;
  originalProfileImg: string;
  parentAccount: string;
  createdBy: string;
  email: string;
  phone: string;
  address: string;
  photo: string;
  originalPhoto: string;
  startPage: START_PAGE;
  newsLetter: boolean;
  companyName: string;
  companyAddress: string;
  companyPhoneNumber: string;
  department: string;
  description: string;
  jobTitle: string;
  notifyAlertMail: boolean;
  notifyReportMail: boolean;
  notifySms: boolean;
  notifyPush: boolean;
  isActivate: boolean;
  userTimezone: string;
  use2faCode: string;
  createAt: string;
  lastLoggedOn: string;
  deletedDate: string;
  userGroups: UserGroupInfo[];

  userGroupCount: number;
  provider: string;
  level: string[];
  enableEdit: boolean;
  invitedBy: string;
  invitedEmail: string;
  invitedDate: string;
  hostValidation: boolean;
  isTrial: boolean;
  verifyPhone: boolean;
  passkeyList: Passkey[];
  restrictList: RestrictedRecorder[];
  isTemporaryAccess: boolean;
  temporaryAccessExpiredAt: string;
}

export type CreateUserRequest = AddUserDto;

export interface CRUDUserResponse {
  error: number;
  errorString: string;
  result: UserDto;
}
export type UpdateUserRequest = UserDto;

export type GetGroupRequest = BasePagination;

export interface UserGroupUserPermission {
  enableAllPermissions: boolean;
  manageAlertRules: boolean;
  viewAlerts: boolean;
  manageUsersAndGroups: boolean;
  viewUsersAndGroups: boolean;
  manageReportRules: boolean;
  viewReports: boolean;
  manageRecordersAndGroups: boolean;
  viewRecordersAndGroups: boolean;
  manageAccount: boolean;
  viewAccount: boolean;
  view: boolean;
  manageBillingAndLicenses: boolean;
  groupName?: string;
  enableDelete?: boolean;
  subscriptionOrganization: boolean;
  suspend: boolean;
  lowLevelAccess: boolean;
  subscriptionKeys: boolean;
  generateKeys: boolean;
  serviceAndPricing: boolean;
  serviceAndPricingUpdate: boolean;
  cumulus: boolean;
  generateCumulus: boolean;
  myOrganization?: boolean;
  videoGuideSetting?: boolean;
  techSupport?: boolean;
  siteNotice?: boolean;
  emails?: boolean;
  viewSubscription: boolean;
  manageSubscription: boolean;
  announcement: boolean;
  logging: boolean;
  releaseNotes: boolean;
  manageMaintenance: boolean;
}
export type StrictUserPermissionKey = keyof UserGroupUserPermission;

export interface SpectrumPermission {
  cameraSetting: boolean; // Edit Settings
  viewArchive: boolean;
  exportArchive: boolean;
  viewBookmark: boolean;
  modifyBookmark: boolean; // Manage Bookmarks
  viewLive: boolean; //View Live
  cameraUserInput: boolean; // User Input
}

export interface VmaxPermission {
  system: boolean;
  alarm: boolean;
  shutdown: boolean;
  playback: boolean;
  search: boolean;
  device: boolean;
  export: boolean;
  ptz: boolean;
  backup: boolean;
  network: boolean;
  record: boolean;
}
export interface CovaPermission {
  localCamera: boolean;
  remoteCamera: boolean;
  disk: boolean;
  aiEvent: boolean;
  schedule: boolean;
  localSystem: boolean;
  remoteSystem: boolean;
  accountAuthority: boolean;
  remoteLogin: boolean;
  network: boolean;
  record: boolean;
  talkback: boolean;
}

export interface RecorderTypePermissionWithoutRole {
  spectrum: SpectrumPermission;
  vmax: VmaxPermission;
  cova: CovaPermission;
}

export interface UserGroupRecorderTypePermission {
  spectrum: { role: SpectrumRoleLevel } & SpectrumPermission;
  vmax: { role: NVRRoleLevel } & VmaxPermission;
  cova: { role: NVRRoleLevel } & CovaPermission;
}

export interface UserGroupRecorderPermission
  extends UserGroupRecorderTypePermission {
  // recorderPermissionLevel: string;
}

export interface UserGroupSystemCamera {
  channel: number;
  cameraId?: string;
  thumbnailUrl?: string;
  isDisabled: boolean;
  isAccess: boolean;
  cameraUuid?: string;
}
export interface UserGroupSystem {
  mergedSystemId: string;
  mergedSystemName: string;
  displayType: string;
  brand: string;
  location: string;
  maxCameras: number;
  cameraCount: number;
  allCameras: boolean;
  cameras?: UserGroupSystemCamera[];
  firmwareVersion: string;
}

export interface UserGroupListItem {
  groupId: string;
  name: string;
  hostEmail: string;
  hostName: string;
  hostValidation: boolean;
  hasUsers: number;
  hostChange: boolean;
  description: string;
  enableDelete: boolean;
  userId: string;
}

export interface UserGroupInfo extends UserGroupListItem {
  userPermission: UserGroupUserPermission;
  users: string[];
  accounts: string[];
  autoApplyAccount: boolean;
  autoApplyRecorder: boolean;
  systems: UserGroupSystem[];
  recorderGroups: number[];
  recorderPermission: UserGroupRecorderPermission;
}

export interface GetGroupListResposne extends CommonPageResponse {
  result: UserGroupListItem[];
}

export interface UserGroupCUSystemCamera {
  channel: number;
  cameraId?: string;
  cameraUuid?: string;
  isAccess: boolean;
}

export interface UserGroupCUSystem {
  mergedSystemId: string;
  displayType: string;
  allCameras: boolean;
  cameras?: UserGroupCUSystemCamera[];
}

export type UserGroupCURequest = Pick<
  UserGroupInfo,
  | "name"
  | "description"
  | "userPermission"
  | "recorderPermission"
  | "autoApplyAccount"
  | "autoApplyRecorder"
> & {
  users?: string[];
  systems?: UserGroupCUSystem[];
  recorderGroups?: number[];
  accounts?: string[];
};

export type CreateGroupRequest = UserGroupCURequest;
export type UpdateGroupRequest = UserGroupCURequest;

export interface CUDGroupResponse {
  error: number;
  errorString: string;
  result: UserGroupInfo;
}

export type GetRoleRequest = BasePagination;

export interface Role {
  roleId: string;
  name: string;
  description: string;
  viewCameraFootage: boolean;
  viewRecordedFootage: boolean;
  viewReport: boolean;
  viewAlert: boolean;
  ptzControl: boolean;
  accountManagement: boolean;
  addEditReport: boolean;
  addEditAlert: boolean;
  userManagement: boolean;
}

export interface GetRoleListResposne {
  error: number;
  errorString: string;
  result: ({
    roleId: string;
    name: string;
    description: string;
    viewCameraFootage: boolean;
    viewRecordedFootage: boolean;
    viewReport: boolean;
    viewAlert: boolean;
    ptzControl: boolean;
    accountManagement: boolean;
    addEditReport: boolean;
    addEditAlert: boolean;
    userManagement: boolean;
  } & Role)[];
  page: {
    total: number;
    pageNum: number;
    pageLimit: number;
    keyword: string;
    sortType: SORT_TYPE;
    sortDirection: SORT_DIRECTION;
  };
}

export type CreateRoleRequest = Role;
export type UpdateRoleRequest = Role;

export interface SearchUserList {
  userId: string;
  name: string;
  email: string;
}

export interface SearchUserAllList {
  // userId: string;
  name: string;
  email: string;
}
export interface updateProfileIamgeResponse {
  error: number;
  result: string;
}

export interface GetUserAllList {
  error: number;
  errorString: string;
  result: SearchUserAllList[];
}

export interface PhoneVerify {
  isVerify: boolean;
  verifyCode: string;
  correctCode: string;
  originalPhoneNumber: string;
}

export interface RequestTemporaryBody {
  recipient: string;
  duration: number;
}

export interface RequestTemporaryResponse extends CommonResponse {
  result: RequestTemporaryBody;
}
